import { render } from "./InspectionForm.vue?vue&type=template&id=26067b54&scoped=true"
import script from "./InspectionForm.vue?vue&type=script&lang=js"
export * from "./InspectionForm.vue?vue&type=script&lang=js"

import "./InspectionForm.vue?vue&type=style&index=0&id=26067b54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26067b54"

export default script